import { useTranslation } from "next-i18next";
import { ITagsData } from "src/api/server/extended-search";
import { TagsFilterBodyContent } from "src/components/pages/search/components/tags-filter/tags-filter-body-content";
import { ISearch } from "src/components/pages/search/search.types";
import { handleResetTags } from "src/components/pages/search/store/actions";
import { useSearchStore } from "src/components/pages/search/store/search-store";
import { PopperWrapper } from "../popover/popper-wrapper";

const TAGS_POPOVER_BUTTON_TEST_ID = "tags-popover-button";

interface ITagsPopover extends ISearch {
    tagsData: ITagsData;
}

export const TagsPopover = ({ tagsData, onSearch }: ITagsPopover) => {
    const { tags: selectedTags } = useSearchStore();
    const { t } = useTranslation("extended-search");

    const { basics, tradings, rewards, investmentHorizon, investmentRegion, alphaBeta } = tagsData.tags;
    const numbersOfTags =
        basics.tags.length +
        tradings.tags.length +
        rewards.tags.length +
        investmentHorizon.tags.length +
        investmentRegion.tags.length +
        alphaBeta.tags.length;

    const resetTags = () => {
        handleResetTags(onSearch);
    };

    return (
        <PopperWrapper
            buttonTestId={TAGS_POPOVER_BUTTON_TEST_ID}
            placement="bottom-end"
            id={t("tags")}
            buttonProps={{
                title: t("tags"),
                badgeInfo: `${selectedTags.length} / ${numbersOfTags}`,
            }}
            boxSx={{
                width: "487px",
                p: 3,
            }}
        >
            <TagsFilterBodyContent onSearch={onSearch} tagsData={tagsData} resetTags={resetTags} />
        </PopperWrapper>
    );
};
